// The 20 Abuse Playbook techniques, rendered on the Social Media IQ page
// beneath the platform threat matrix.
//
// Copied verbatim from the marketing site's Abuse Playbook page
// (src/pages/AbusePlaybook.js), which is sourced from QA_NuV_Abuse Playbook.docx.
// This list replaced an older, longer 25-tactic set recovered from the retired
// dashboard Abuser Playbook page; the two now agree, and the .docx is the
// authority. Keep them in sync — edit the .docx wording in both places.

const MANIPULATION_TACTICS = [
  {
    number: 1,
    title: "Gaslighting",
    description:
      "Targets start to question their own memories, perceptions, and sanity. Abusers use a mixture of denial, misdirection, contradiction, and lying to produce feelings of confusion, anxiety, and uncertainty about their own reality.",
  },
  {
    number: 2,
    title: "Emotional Blackmail",
    description:
      "Guilt, fear, or shame — withholding approval, love, or support until the target yields to the abuser's wishes.",
  },
  {
    number: 3,
    title: "Psychological Manipulation",
    description:
      "Lying, deceit, fake information or shading the truth to their own benefit, breaking down trust and leaving victims open to further manipulation.",
  },
  {
    number: 4,
    title: "Love Bombing",
    description:
      "Quickly professing affection. Excessive praise designed to create a deep emotional bond, making it difficult for the victim to break off the interaction.",
  },
  {
    number: 5,
    title: "Emotional Confinement",
    description:
      "Isolation creating dependency on the abuser. Convincing the subject to keep their connections hidden from friends, family, or any other sources of support, allowing the predator to exert control and restrict intervention.",
  },
  {
    number: 6,
    title: "Panic",
    description:
      "Instilling feelings of anxiety, uncertainty, or dread, creating a sense of urgency and dependency on the abuser for protection or guidance.",
  },
  {
    number: 7,
    title: "Blame Game",
    description:
      "Playing up their own suffering, portraying themselves as victims to elicit feelings of guilt leading to sympathy from the target.",
  },
  {
    number: 8,
    title: "Intimidation",
    description:
      "Aggressive interaction to enforce compliance: verbal threats and demonstrations of authority.",
  },
  {
    number: 9,
    title: "Reflection",
    description:
      "Build a common belief and trust with the target. Establishing an emotional connection allows the predator to put the target at ease, creating a trust bond and making the target open to being influenced and controlled.",
  },
  {
    number: 10,
    title: "Adulation",
    description:
      "Using ongoing flattery and charm to disarm the target and move them through the different abuse phases. Predators appeal to the victim's ego, establishing an emotional connection that obscures rational thinking.",
  },
  {
    number: 11,
    title: "Mental Conflict",
    description:
      "Having two different beliefs creating a conflict between emotions and logic. Abusers will introduce contradictory information, sowing confusion in their target.",
  },
  {
    number: 12,
    title: "Camel nose under the tent",
    description:
      "Coaching someone to agree to a small request before presenting a larger one. Once a person has agreed to something small, they are more likely to agree to something larger later.",
  },
  {
    number: 13,
    title: "Switcheroo",
    description:
      "Coaches the victim with appealing promises to change their life conditions. A key technique in catfishing (romance), pig butchering (cryptocurrency) or other types of investment fraud.",
  },
  {
    number: 14,
    title: "Authority Exploitation",
    description:
      "Amplify their authority, expertise or life experience to build trust and influence the target to act. Presenting themselves as knowledgeable enables them to gain the trust and compliance of their victims.",
  },
  {
    number: 15,
    title: "Scammer-in-the-middle",
    description:
      "Create discord and rivalry between the targets and their family and friends. This ensures the target will remain dependent upon the abuser throughout the abuse lifecycle.",
  },
  {
    number: 16,
    title: "Reverse psychology",
    description:
      "Designed to evoke a specific reaction or behavior aligning with the abusers' true intentions. Ideas and suggestions are presented in a reverse manner. Often the target is unaware the manipulation is occurring.",
  },
  {
    number: 17,
    title: "Degradation",
    description:
      "Abusers use shaming and humiliation to exert control over their targets. It undermines a person's judgement, self-esteem and sense of worth, increasing the victim's reliance on the abuser.",
  },
  {
    number: 18,
    title: "Filtration",
    description:
      "Seduction or sexualizing to gain or maintain control. By exploiting their targets' emotional and physical desires, manipulators gain control and influence over the target.",
  },
  {
    number: 19,
    title: "Brainwashing",
    description:
      "An emotional connection — empathy. Abusers use a combination of kindness and manipulation alongside the abuse, leading the victim to sympathize with and defend their abusers.",
  },
  {
    number: 20,
    title: "Playing the Victim Card",
    description:
      "Frequently predators adopt the role of the victim to evoke sympathy, induce feelings of guilt, or divert attention from their own deceitful behavior. They present themselves as powerless, unjustly treated, or unfairly maligned to coerce others into providing support or fulfilling their own selfish desires.",
  },
];

export default MANIPULATION_TACTICS;
